import {
	CAPACITY_CRITICAL_THRESHOLD,
	CAPACITY_WARNING_THRESHOLD,
} from 'src/constants/vaults/misc';
import { cm } from 'src/utils/classNames';

export const VaultCapacityProgressBar = ({
	capacityPct,
	primaryBg = 'bg-text-secondary',
	warningBg,
	criticalBg,
	heightClass = 'h-xs',
}: {
	capacityPct: number;
	primaryBg?: string;
	warningBg?: string;
	criticalBg?: string;
	heightClass?: string;
}) => {
	return (
		<div
			className={cm(
				'w-full overflow-hidden rounded-full bg-tooltip-bg',
				heightClass
			)}
		>
			<div
				className={cm(
					'h-full',
					capacityPct >= CAPACITY_CRITICAL_THRESHOLD
						? (criticalBg ?? primaryBg)
						: capacityPct >= CAPACITY_WARNING_THRESHOLD
							? (warningBg ?? primaryBg)
							: primaryBg
				)}
				style={{ width: `${capacityPct}%` }}
			></div>
		</div>
	);
};
